<template>
  <div id="closest-route">
    <h4></h4>

    <!-- utility row -->
    <div class="row"></div>

    <div class="row">
      <div
        v-for="(nearbyStop, index) in stops"
        :key="index"
        class="closest-stop-row row"
      >
        <NearbyStop
          :stop="nearbyStop"
        ></NearbyStop>

      </div>
    </div>

    <div class="row">
      <div
        v-for="(nearbyRoute, index) in nearbyRoutesWithSpecialIcons"
        :key="index"
        class="closest-row row"
      >
        <router-link
          :to="{
                        name: 'closestStopByRoute',
                        params: {
                            id: nearbyRoute.routeid
                        }
                    }"
          class="closest-row-a"
        >
          <div class="routec">{{ nearbyRoute.routec }}</div>
          <div class="destins">{{ nearbyRoute.startc + " ↔ " + nearbyRoute.destinc }}</div>
          <div
            v-if="nearbyRoute.specialIcon"
            class="special-route"
          >
            <md-icon>{{ nearbyRoute.specialIcon }}</md-icon>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import NearbyStop from "../NearbyStop/NearbyStop";

export default {
  name: "ClosestRoute",
  components: {NearbyStop},
  computed: {
    ...mapState('nearbyRoutes', ['routes', 'stops']),
    nearbyRoutesWithSpecialIcons() {
      return this.routes.map(x => {
        let specialIcon = 'priority_high';

        if (x.service_mode === "R") {
          specialIcon = null;
        } else if (x.service_mode.toLowerCase().includes('n')) {
          specialIcon = 'brightness_3';
        }

        return {
          ...x,
          specialIcon,
        };
      })
    },

  },
  methods: {
    ...mapActions('nearbyRoutes', ['getNearbyRouteList']),

  },
  mounted() {
    this.getNearbyRouteList();
  },
}
</script>

<style scoped>
.closest-row, .closest-stop-row {
  border-bottom: 1px solid #CCCCCC;
  padding: 8px;
  height: 40px;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
}

.closest-stop-row {
  height: 60px;
}

.closest-row-a {
  width: 100%;
  overflow: hidden;
}

.routec, .destins, .special-route {
  line-height: 24px;
  display: inline-block;
}

.routec {
  width: 55px;
  font-weight: bold;
}

.destins {
}

.special-route {
  position: absolute;
  right: 8px;
  top: 8px;
}
</style>
